// Import CSS for bundling (Update Cache Busting)
import "./style.css";
// Import config
import { SSO_CONFIG } from "./config.js";

import logo from "./logo-new.png";
import presensiLogo from "./assets/logo-digital-office-white.png";

// SSO Topbar main logic - Updated for cache busting
// Update 11 update updte

console.log("SSO_CONFIG", SSO_CONFIG);

document.addEventListener("DOMContentLoaded", function () {
	let ssoToken = "";
	let isDropdownOpen = false;
	let isUserDropdownOpen = false;
	let userInfo = null; // Add user info storage
	let showPresensiButton = false; // Default hide presensi button
	let serviceSubtitle = ""; // Subtitle untuk nama layanan
	let customHtml = ""; // Custom HTML untuk injection (hamburger menu, dll)

	// Fungsi untuk validasi domain parent (yang memuat iframe)
	function isValidParentDomain() {
		try {
			const referrer = document.referrer;
			if (!referrer) {
				console.error("Access denied: No referrer found");
				return false;
			}
			const referrerUrl = new URL(referrer);
			const referrerHostname = referrerUrl.hostname;
			const isValid = SSO_CONFIG.ALLOWED_PARENT_DOMAINS.some((domain) => {
				return (
					referrerHostname === domain || referrerHostname.endsWith("." + domain)
				);
			});
			if (!isValid) {
				console.error(
					"Access denied: Parent domain not in whitelist",
					referrerHostname
				);
			}
			return isValid;
		} catch (error) {
			console.error("Error validating parent domain:", error);
			return false;
		}
	}

	// Fungsi untuk validasi domain
	function isValidDomain(url) {
		try {
			const urlObj = new URL(url);
			const hostname = urlObj.hostname;
			return SSO_CONFIG.ALLOWED_DOMAINS.some((domain) => {
				return hostname === domain || hostname.endsWith("." + domain);
			});
		} catch (error) {
			console.error("Invalid URL:", error);
			return false;
		}
	}

	// Fungsi untuk validasi origin
	function isValidOrigin(origin) {
		return SSO_CONFIG.ALLOWED_ORIGINS.includes(origin);
	}

	// Fungsi untuk menampilkan pesan akses ditolak
	function showAccessDenied() {
		document.getElementById("content").innerHTML = `
      <div class="access-denied">
        <h2>🔒 Akses Ditolak</h2>
        <p>Topbar SSO hanya dapat diakses dari domain yang terdaftar.</p>
        <p><strong>Domain yang diizinkan:</strong></p>
        <ul style="text-align: left; display: inline-block;">
          ${SSO_CONFIG.ALLOWED_PARENT_DOMAINS.map(
			(domain) => `<li>${domain}</li>`
		).join("")}
        </ul>
        <p style="margin-top: 20px; font-size: 12px;">
          Jika Anda yakin domain Anda seharusnya diizinkan, 
          silakan hubungi administrator sistem.
        </p>
      </div>
    `;
	}

	// Fungsi untuk login
	window.handleLogin = function handleLogin() {
		const loginUrl =
			"https://digitaloffice.kemenhub.go.id/layanan-presensi/auth/check-session";
		gotoApp(loginUrl);
	};

	// Fungsi untuk logout
	window.handleLogout = function handleLogout() {
		// Kirim pesan ke parent window untuk menampilkan alert logout
		window.top.postMessage(
			{
				type: "USER_LOGOUT_REQUEST",
				message: "User ingin logout dari sistem"
			},
			"*"
		);

		// Reset state lokal
		ssoToken = '';
		userInfo = null;
		updateAuthUI();
		console.log('User logged out - alert sent to parent');
	};

	// Fungsi untuk toggle dropdown: kirim pesan ke parent
	window.toggleDropdown = function toggleDropdown() {
		isDropdownOpen = !isDropdownOpen;
		const dropdownButton = document.querySelector(".dropdown-button");
		const buttonRect = dropdownButton.getBoundingClientRect();

		// Kirim pesan ke parent window untuk menampilkan/menyembunyikan dropdown
		window.top.postMessage(
			{
				type: "TOGGLE_DROPDOWN",
				isOpen: isDropdownOpen,
				apps: SSO_CONFIG.APPS,
				// Serializable-kan DOMRect object
				buttonRect: JSON.parse(JSON.stringify(buttonRect)),
			},
			"*"
		); // Ganti '*' dengan origin parent yang spesifik di production

		// Update state tombol secara lokal
		setDropdownButtonState(isDropdownOpen);
	};

	// Fungsi untuk toggle dropdown user
	window.toggleUserDropdown = function toggleUserDropdown() {
		isUserDropdownOpen = !isUserDropdownOpen;
		const userAvatar = document.querySelector(".user-avatar");
		const buttonRect = userAvatar.getBoundingClientRect();

		// Kirim pesan ke parent window untuk menampilkan/menyembunyikan dropdown user
		window.top.postMessage(
			{
				type: "TOGGLE_USER_DROPDOWN",
				isOpen: isUserDropdownOpen,
				userInfo: userInfo,
				// Serializable-kan DOMRect object
				buttonRect: JSON.parse(JSON.stringify(buttonRect)),
			},
			"*"
		);

		// Update state tombol secara lokal
		setUserDropdownButtonState(isUserDropdownOpen);
	};

	// Fungsi untuk mengeset state visual tombol dropdown
	function setDropdownButtonState(isOpen) {
		const dropdownButton = document.querySelector(".dropdown-button");
		isDropdownOpen = isOpen;
		if (isOpen) {
			dropdownButton.classList.add("active");
		} else {
			dropdownButton.classList.remove("active");
		}
	}

	// Fungsi untuk mengeset state visual tombol dropdown user
	function setUserDropdownButtonState(isOpen) {
		const userAvatar = document.querySelector(".user-avatar");
		isUserDropdownOpen = isOpen;
		if (isOpen) {
			userAvatar.classList.add("active");
		} else {
			userAvatar.classList.remove("active");
		}
	}

	// Fungsi untuk update UI berdasarkan status auth
	function updateAuthUI() {
		const loginBtn = document.getElementById("loginBtn");
		const userInfoElement = document.querySelector(".user-info");
		if (ssoToken) {
			// Hide login button, show user info
			if (loginBtn) loginBtn.style.display = "none";
			if (loginBtn) loginBtn.classList.add("hidden");
			if (userInfoElement) userInfoElement.classList.add("show"); userInfoElement.classList.remove("hidden");
		} else {
			// Show login button, hide user info
			if (loginBtn) loginBtn.style.display = "block";
			if (loginBtn) loginBtn.classList.remove("hidden");
			if (userInfoElement) userInfoElement.classList.remove("show"); userInfoElement.classList.add("hidden");
		}
	}

	// Fungsi untuk update visibility button presensi
	function updatePresensiButtonVisibility() {
		const presensiBtn = document.getElementById('presensiBtn');
		console.log('Presensi button element:', presensiBtn);
		console.log('Show presensi button:', showPresensiButton);
		if (presensiBtn) {
			if (showPresensiButton) {
				presensiBtn.style.display = 'flex';
				console.log('Setting presensi button to visible');
			} else {
				presensiBtn.style.display = 'none';
				console.log('Setting presensi button to hidden');
			}
		} else {
			console.log('Presensi button not found');
		}
	}

	// Fungsi untuk update subtitle layanan
	function updateServiceSubtitle() {
		const serviceSubtitleElement = document.querySelector('.service-subtitle-text');
		if (serviceSubtitleElement) {
			serviceSubtitleElement.textContent = serviceSubtitle;
		} else if (serviceSubtitle) {
			// Jika elemen belum ada tapi ada subtitle, tambahkan elemen
			const brandElement = document.querySelector('.brand');
			if (brandElement) {
				const serviceSubtitleDiv = document.createElement('div');
				serviceSubtitleDiv.className = 'service-subtitle';
				serviceSubtitleDiv.innerHTML = `<div class="service-subtitle-text">${serviceSubtitle}</div>`;
				brandElement.appendChild(serviceSubtitleDiv);
			}
		}
	}

	// Fungsi untuk update custom HTML
	function updateCustomHtml() {
		const customHtmlElement = document.querySelector('.custom-html-container');
		if (customHtmlElement) {
			customHtmlElement.innerHTML = customHtml;
			// Add event listeners untuk custom HTML elements
			addCustomHtmlEventListeners(customHtmlElement);
		} else if (customHtml) {
			// Jika elemen belum ada tapi ada custom HTML, tambahkan elemen
			const brandElement = document.querySelector('.brand');
			if (brandElement) {
				const customHtmlDiv = document.createElement('div');
				customHtmlDiv.className = 'custom-html-container';
				customHtmlDiv.innerHTML = customHtml;

				// Insert sebelum service-subtitle jika ada, atau di akhir brand
				const serviceSubtitleElement = brandElement.querySelector('.service-subtitle');
				if (serviceSubtitleElement) {
					brandElement.insertBefore(customHtmlDiv, serviceSubtitleElement);
				} else {
					brandElement.appendChild(customHtmlDiv);
				}

				// Add event listeners untuk custom HTML elements
				addCustomHtmlEventListeners(customHtmlDiv);
			}
		}
	}

	// Fungsi untuk menambahkan event listeners ke custom HTML elements
	function addCustomHtmlEventListeners(container) {
		// Handle clicks pada button dan link di custom HTML
		container.addEventListener('click', function (event) {
			event.preventDefault();
			event.stopPropagation();

			// Kirim pesan ke parent window
			window.parent.postMessage({
				type: 'CUSTOM_HTML_CLICK',
				element: event.target.tagName,
				className: event.target.className,
				id: event.target.id,
				text: event.target.textContent
			}, '*');
		});
	}

	// Fungsi untuk update user info display
	function updateUserInfoDisplay() {
		const userInfoElement = document.querySelector(".user-info");

		if (
			userInfoElement &&
			userInfo &&
			ssoToken &&
			userInfo !== null &&
			ssoToken !== null
		) {
			userInfo = JSON.parse(userInfo);
			// Update user avatar with photo if available
			const userAvatar = userInfoElement.querySelector(".user-avatar");
			if (userInfo.foto) {
				userAvatar.innerHTML = `<img src="${userInfo.foto}" alt="User Photo" style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover;">`;
			} else {
				userAvatar.textContent = userInfo.name
					? userInfo.name.charAt(0).toUpperCase()
					: "U";
			}

			// Update user name
			const userNameSpan = userInfoElement.querySelector(".user-name");
			if (userNameSpan) {
				userNameSpan.textContent = userInfo.name || "User";
			}

			updateAuthUI();
		}
	}

	// Fungsi untuk menampilkan topbar
	function showTopbar() {
		// Dropdown menu tidak lagi di-render di dalam iframe.
		// Parent window akan menanganinya.
		document.getElementById("content").innerHTML = `
      <nav>
        <div class="container">
          <!-- Kiri: Logo dan Judul -->
          <div class="brand" style="display: flex; align-items: center; text-decoration: none;cursor: pointer; " >
            <a href="https://digitaloffice.kemenhub.go.id" style="display: flex; align-items: center; text-decoration: none; cursor: pointer;gap: 12px;" target="_parent" >
              <img src="${presensiLogo}" alt="Logo" class="brand-logo" style="cursor: pointer;">
              <div class="brand-text">
                <div class="brand-title">DIGITAL OFFICE</div>
                <div class="brand-subtitle">Kementerian Perhubungan</div>
              </div>
            </a>
            ${customHtml ? `
            <div class="custom-html-container">
              ${customHtml}
            </div>
            ` : ''}
            ${serviceSubtitle ? `
            <div class="service-subtitle">
              <div class="service-subtitle-text">${serviceSubtitle}</div>
            </div>
            ` : ''}
          </div>
          
          <!-- Kanan: Menu dan Profil -->
          <div class="nav-right">
			<a href="https://hubnet.kemenhub.go.id" class="glass-card" id="hubnetBtn" style="cursor: pointer;flex;" onclick="navigateParent('https://hubnet.kemenhub.go.id')">
				<div class="agenda-link" style="padding: 0 5px;">
					<svg width="25" height="25" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_466_109)">
						<path d="M27.2109 27.2101L45.534 29.4171L36.2338 34.2266C35.3663 34.6751 34.6759 35.3655 34.2274 36.233L29.4179 45.5332L27.2109 27.2101ZM27.1519 24.8438C25.7887 24.8438 24.6911 26.0417 24.8563 27.4344L27.087 45.9581C27.2463 47.2622 28.3203 47.9999 29.4061 47.9999C30.2028 47.9999 30.9995 47.6045 31.4479 46.7429L36.3223 37.3129C36.5406 36.888 36.8888 36.5398 37.3137 36.3215L46.7437 31.4471C48.7678 30.3967 48.219 27.3635 45.9589 27.0921L27.4352 24.8615C27.3407 24.8497 27.2463 24.8438 27.1519 24.8438Z" fill="#fff"/>
						<path d="M18.5883 2.46668L20.7953 20.7898L2.47223 18.5827L11.7725 13.7733C12.6399 13.3248 13.3304 12.6344 13.7788 11.7669L18.5883 2.46668ZM18.5942 0C17.7975 0 17.0009 0.395377 16.5524 1.25695L11.678 10.687C11.4597 11.1119 11.1115 11.46 10.6866 11.6784L1.25659 16.5527C-0.767503 17.6031 -0.218695 20.6363 2.04145 20.9078L20.5652 23.1384C20.6596 23.1502 20.754 23.1561 20.8484 23.1561C22.2116 23.1561 23.3092 21.9582 23.144 20.5655L20.9133 2.0418C20.754 0.737644 19.68 0 18.5942 0Z" fill="#fff"/>
						<path d="M20.7898 27.2101L18.5828 45.5332L13.7734 36.233C13.3249 35.3655 12.6344 34.6751 11.767 34.2266L2.46675 29.4171L20.7898 27.2101ZM20.8488 24.8438C20.7544 24.8438 20.66 24.8438 20.5656 24.8615L2.04186 27.0921C-0.224181 27.3635 -0.772988 30.4026 1.25701 31.4471L10.6871 36.3215C11.1119 36.5398 11.4601 36.888 11.6785 37.3129L16.5528 46.7429C16.9954 47.5986 17.798 47.9999 18.5946 47.9999C19.6804 47.9999 20.7544 47.2622 20.9138 45.9581L23.1444 27.4344C23.3096 26.0358 22.212 24.8438 20.8488 24.8438Z" fill="#fff"/>
						<path d="M29.4179 2.46668L34.2274 11.7669C34.6759 12.6344 35.3663 13.3248 36.2338 13.7733L45.534 18.5827L27.2109 20.7898L29.4179 2.46668ZM29.4061 0C28.3203 0 27.2463 0.737644 27.087 2.0418L24.8563 20.5655C24.6911 21.9641 25.7887 23.1561 27.1519 23.1561C27.2463 23.1561 27.3407 23.1561 27.4352 23.1384L45.9589 20.9078C48.2249 20.6363 48.7737 17.5972 46.7437 16.5527L37.3137 11.6784C36.8888 11.46 36.5406 11.1119 36.3223 10.687L31.4479 1.25695C31.0054 0.401279 30.2028 0 29.4061 0Z" fill="#fff"/>
						</g>
						<defs>
						<clipPath id="clip0_466_109">
						<rect width="48" height="48" fill="white"/>
						</clipPath>
						</defs>
					</svg>

				</div>
			</a>
			<a href="https://digitaloffice.kemenhub.go.id/layanan-presensi/auth/check-session" class="glass-card" id="presensiBtn" style="cursor: pointer; display: ${showPresensiButton ? 'flex' : 'none'};" onclick="navigateParent('https://digitaloffice.kemenhub.go.id/layanan-presensi/auth/check-session')">
				<div class="agenda-link">
					<svg width="25" height="25" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M39.2541 9.23067C38.9072 9.23067 38.5622 9.108 38.2862 8.855C34.0561 4.99867 28.6281 2.875 23.0007 2.875C17.3734 2.875 11.9454 4.99867 7.71532 8.85692C7.1269 9.39167 6.2184 9.34758 5.68365 8.763C5.1489 8.1765 5.19107 7.26608 5.77757 6.73133C10.5405 2.39008 16.6566 0 23.0007 0C29.3449 0 35.461 2.39008 40.2239 6.73133C40.8104 7.26608 40.8526 8.17458 40.3178 8.763C40.0342 9.0735 39.6451 9.23067 39.2541 9.23067Z" fill="#fff"/>
						<path d="M41.6882 18.6238C41.2263 18.6238 40.7701 18.4015 40.4941 17.9875C36.5036 12.0458 29.9639 8.49808 23.0007 8.49808C16.0374 8.49808 9.49777 12.0458 5.50727 17.9875C5.06452 18.6488 4.16944 18.8232 3.51202 18.3804C2.85269 17.9377 2.67635 17.0445 3.1191 16.3852C7.64435 9.64808 15.0772 5.625 23.0007 5.625C30.9242 5.625 38.357 9.64808 42.8823 16.3871C43.325 17.0464 43.1506 17.9396 42.4893 18.3823C42.244 18.5453 41.9661 18.6238 41.6882 18.6238Z" fill="#fff"/>
						<path d="M18.4595 45.9997C18.0896 45.9997 17.7196 45.8579 17.4379 45.5742C17.1236 45.2579 9.75781 37.7389 9.75781 30.4996C9.75781 22.9863 15.6976 16.874 23.0001 16.874C30.3026 16.874 36.2423 22.9863 36.2423 30.4996C36.2423 31.2931 35.5983 31.9371 34.8048 31.9371C34.0113 31.9371 33.3673 31.2931 33.3673 30.4996C33.3673 24.5714 28.7175 19.749 23.0001 19.749C17.2826 19.749 12.6328 24.5714 12.6328 30.4996C12.6328 36.5697 19.4121 43.4812 19.4811 43.5502C20.0407 44.1137 20.0369 45.0241 19.4715 45.5838C19.1916 45.8617 18.8256 45.9997 18.4595 45.9997Z" fill="#fff"/>
						<path d="M27.5425 45.9995C24.0848 45.9995 16.0693 39.4215 15.2931 32.096C15.019 29.5066 15.8432 26.8578 17.4953 25.0101C18.9328 23.4039 20.8744 22.5127 22.9617 22.5012H23.0019C25.0374 22.5012 26.9617 23.3004 28.4261 24.7552C29.9556 26.2751 30.797 28.3164 30.797 30.5014V31.4386C30.797 33.7482 32.5948 35.6265 34.8067 35.6265C37.0185 35.6265 38.8182 33.7482 38.8182 31.4386V31.1109C38.8182 22.16 32.3342 14.7138 24.0561 14.1618C19.7417 13.8685 15.5997 15.3597 12.4047 18.3459C9.08883 21.447 7.1875 25.8784 7.1875 30.5014C7.1875 34.304 8.4755 38.0089 10.8138 40.9338C11.3083 41.5548 11.2087 42.4575 10.5877 42.9539C9.96858 43.4504 9.06392 43.3507 8.5675 42.7278C5.82475 39.295 4.3125 34.9519 4.3125 30.4994C4.3125 25.0829 6.54733 19.8869 10.4401 16.2452C14.2217 12.707 19.1264 10.9456 24.2458 11.2906C34.0285 11.9442 41.6932 20.6497 41.6932 31.1089V31.4367C41.6932 35.3314 38.6036 38.4996 34.8067 38.4996C31.0097 38.4996 27.922 35.3314 27.922 31.4367V30.4994C27.922 29.0849 27.3815 27.7701 26.4002 26.7926C25.4802 25.8764 24.2746 25.3743 23.0038 25.3743C22.9942 25.3743 22.9866 25.3743 22.977 25.3743C21.3574 25.3819 20.2668 26.2234 19.6382 26.9268C18.5169 28.1784 17.9611 29.9992 18.1508 31.7932C18.7852 37.7694 25.6527 43.1264 27.5425 43.1264C28.336 43.1264 28.98 43.7704 28.98 44.5639C28.98 45.3574 28.336 45.9995 27.5425 45.9995Z" fill="#fff"/>
						<path d="M32.8745 43.1883C27.7301 43.1883 21.4492 36.9017 21.4492 29.5627C21.4492 28.7692 22.0932 28.1252 22.8867 28.1252C23.6802 28.1252 24.3242 28.7692 24.3242 29.5627C24.3242 35.2514 29.1063 40.3133 32.8745 40.3133C33.668 40.3133 34.312 40.9573 34.312 41.7508C34.312 42.5443 33.668 43.1883 32.8745 43.1883Z" fill="#fff"/>
					</svg>
				<span>Presensi</span>
				</div>
			</a>
            <!-- Google-style dropdown button -->
            <div class="glass-card" style="">
              <div class="dropdown-container">
                <button class="dropdown-button" onclick="toggleDropdown()">
                  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_297_126706)">
					<path d="M9.65304 0H1.3052C0.728883 0 0.261719 0.467164 0.261719 1.04348V9.39132C0.261719 9.96763 0.728883 10.4348 1.3052 10.4348H9.65304C10.2294 10.4348 10.6965 9.96763 10.6965 9.39132V1.04348C10.6965 0.467164 10.2294 0 9.65304 0Z" fill="white"/>
					<path d="M22.1745 0H13.8267C13.2504 0 12.7832 0.467164 12.7832 1.04348V9.39132C12.7832 9.96763 13.2504 10.4348 13.8267 10.4348H22.1745C22.7508 10.4348 23.218 9.96763 23.218 9.39132V1.04348C23.218 0.467164 22.7508 0 22.1745 0Z" fill="white"/>
					<path d="M9.65304 12.5218H1.3052C0.728883 12.5218 0.261719 12.9889 0.261719 13.5652V21.9131C0.261719 22.4894 0.728883 22.9566 1.3052 22.9566H9.65304C10.2294 22.9566 10.6965 22.4894 10.6965 21.9131V13.5652C10.6965 12.9889 10.2294 12.5218 9.65304 12.5218Z" fill="white"/>
					<path d="M22.1745 12.5218H13.8267C13.2504 12.5218 12.7832 12.9889 12.7832 13.5652V21.9131C12.7832 22.4894 13.2504 22.9566 13.8267 22.9566H22.1745C22.7508 22.9566 23.218 22.4894 23.218 21.9131V13.5652C23.218 12.9889 22.7508 12.5218 22.1745 12.5218Z" fill="white"/>
					<path d="M34.696 0H26.3482C25.7719 0 25.3047 0.467164 25.3047 1.04348V9.39132C25.3047 9.96763 25.7719 10.4348 26.3482 10.4348H34.696C35.2723 10.4348 35.7395 9.96763 35.7395 9.39132V1.04348C35.7395 0.467164 35.2722 0 34.696 0Z" fill="white"/>
					<path d="M34.696 12.5218H26.3482C25.7719 12.5218 25.3047 12.9889 25.3047 13.5652V21.9131C25.3047 22.4894 25.7719 22.9566 26.3482 22.9566H34.696C35.2723 22.9566 35.7395 22.4894 35.7395 21.9131V13.5652C35.7395 12.9889 35.2722 12.5218 34.696 12.5218Z" fill="white"/>
					<path d="M9.65304 25.5652H1.3052C0.728883 25.5652 0.261719 26.0324 0.261719 26.6087V34.9565C0.261719 35.5328 0.728883 36 1.3052 36H9.65304C10.2294 36 10.6965 35.5328 10.6965 34.9565V26.6087C10.6965 26.0324 10.2294 25.5652 9.65304 25.5652Z" fill="white"/>
					<path d="M22.1745 25.5652H13.8267C13.2504 25.5652 12.7832 26.0324 12.7832 26.6087V34.9565C12.7832 35.5328 13.2504 36 13.8267 36H22.1745C22.7508 36 23.218 35.5328 23.218 34.9565V26.6087C23.218 26.0324 22.7508 25.5652 22.1745 25.5652Z" fill="white"/>
					<path d="M34.696 25.5652H26.3482C25.7719 25.5652 25.3047 26.0324 25.3047 26.6087V34.9565C25.3047 35.5328 25.7719 36 26.3482 36H34.696C35.2723 36 35.7395 35.5328 35.7395 34.9565V26.6087C35.7395 26.0324 35.2722 25.5652 34.696 25.5652Z" fill="white"/>
					</g>
					<defs>
					<clipPath id="clip0_297_126706">
					<rect width="36" height="36" fill="white"/>
					</clipPath>
					</defs>
				</svg>

                </button>
              </div>
              
              <!-- Dropdown menu akan dirender oleh parent -->
            </div>
            
            <!-- Profile section -->
            <div class="profile-section">
              <div class="glass-card" id="loginBtn">
                <button class="login-button" onclick="handleLogin()">
                  <span class="login-icon">👤</span>
                  Login
                </button>
              </div>
              <div class="user-info glass-card hidden" onclick="toggleUserDropdown()" style="cursor: pointer;">
                <div class="user-avatar" >U</div>
                <div class="user-details">
                  <span class="user-name">User</span>
                  <span class="user-email"></span>
                  <span class="user-office"></span>
                </div>
              </div>
              <img style="display: none;" src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpb
            </div>
          </div>
        </div>
      </nav>
    `;

		updateAuthUI();
	}

	// Fungsi global agar bisa dipanggil dari HTML
	window.gotoApp = function gotoApp(url) {
		// if (!isValidDomain(url)) {
		//   console.error('Access denied: Domain not in whitelist', url);
		//   alert('Akses ditolak: Domain tidak diizinkan');
		//   return;
		// }
		const fullUrl = `${url}`;
		if (window.top !== window.self) {
			window.top.location.href = fullUrl;
		} else {
			window.location.href = fullUrl;
		}
	};

	// Fungsi untuk navigasi ke parent window
	window.navigateParent = function navigateParent(url) {
		if (window.top !== window.self) {
			// Jika dalam iframe, kirim pesan ke parent untuk navigasi
			window.top.postMessage(
				{
					type: "NAVIGATE_PARENT",
					url: url
				},
				"*"
			);
		} else {
			// Jika tidak dalam iframe, navigasi langsung
			window.location.href = url;
		}
	};

	// Terima pesan dari parent window
	window.addEventListener("message", (event) => {
		// Disarankan untuk validasi origin di sini demi keamanan
		// if (!isValidOrigin(event.origin)) {
		//   console.error('Access denied: Origin not in whitelist', event.origin);
		//   return;
		// }

		if (event.data.type === "SSO_TOKEN") {
			ssoToken = event.data.token;
			console.log("SSO Token received from:", event.origin);
		} else if (event.data.type === "SSO_USER_INFO") {
			userInfo = event.data.userInfo;
			console.log("SSO User Info received from:", event.origin, userInfo);
			updateUserInfoDisplay();
		} else if (event.data.type === "DROPDOWN_CLOSED") {
			// Parent memberitahu bahwa dropdown ditutup (misal: klik di luar)
			setDropdownButtonState(false);
		} else if (event.data.type === "USER_DROPDOWN_CLOSED") {
			// Parent memberitahu bahwa dropdown user ditutup (misal: klik di luar)
			setUserDropdownButtonState(false);
		} else if (event.data.type === "TOGGLE_PRESENSI_BUTTON") {
			// Parent mengatur show/hide button presensi
			showPresensiButton = event.data.show;
			console.log('Toggle presensi button:', showPresensiButton);
			updatePresensiButtonVisibility();
		} else if (event.data.type === "SET_SERVICE_SUBTITLE") {
			// Parent mengatur subtitle layanan
			serviceSubtitle = event.data.subtitle;
			console.log('Set service subtitle:', serviceSubtitle);
			updateServiceSubtitle();
		} else if (event.data.type === "SET_CUSTOM_HTML") {
			// Parent mengatur custom HTML (hamburger menu, dll)
			customHtml = event.data.html;
			console.log('Set custom HTML:', customHtml);
			updateCustomHtml();
		} else if (event.data.type === "NAVIGATE_APP") {
			// Parent meminta navigasi ke URL aplikasi
			gotoApp(event.data.url);
		}
	});

	// Inisialisasi: cek validasi domain parent
	if (isValidParentDomain()) {
		showTopbar();
		console.log("Topbar SSO loaded successfully");
		console.log("Allowed parent domains:", SSO_CONFIG.ALLOWED_PARENT_DOMAINS);
		console.log("Allowed domains:", SSO_CONFIG.ALLOWED_DOMAINS);
		console.log("Allowed origins:", SSO_CONFIG.ALLOWED_ORIGINS);
	} else {
		// Sementara aktif semua
		showTopbar();
		// showAccessDenied();
		console.error("Topbar SSO access denied - invalid parent domain");
	}
});
